import React from 'react';
import {
    Table,
    Tabs,
    Radio,
    Button,
    Form,
    Row,
    Col,
    Select,
    DatePicker,
    Spin,
} from 'antd';
const FormItem = Form.Item;
const TabPane = Tabs.TabPane;
import { onFieldsChange, getAgentQualityList, getBandwidthDetailList, getBandwidthDetailSortList, getAgentsInfo, getPieData } from './action';
import { connect } from 'react-redux';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';
import { index } from '../../index/reducers';

class widthAndConnect extends React.Component {
    constructor(props) {
        super(props);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
        this.getOtion = this.getOtion.bind(this);
    }

    //页面刷新时触发
    componentDidMount() {
        this.props.getAgentQualityList(); //曲线信息
        this.props.getPieData(); //饼状图信息
        this.props.getAgentsInfo();//代理商信息        
        this.props.getBandwidthDetail();//带宽详细信息
        this.props.getBandwidthDetailSortList();//排名
    }
    handleOnFieldsChange(fields) {
        //console.log("handleOnFieldsChange1");
        let _obj = {};
        Object.keys(fields).forEach((key, index) => {
            if (key === 'startDay') {
                if (fields[key].value == null) { //时间点x号清空时候会为null  so要判空
                    _obj['startDay'] = moment().format('YYYY-MM-DD');
                } else {
                    _obj['startDay'] = moment(fields[key].value).format('YYYY-MM-DD');
                }
            } else if (key === 'endDay') {
                if (fields[key].value == null) { //时间点x号清空时候会为null  so要判空
                    _obj['endDay'] = moment().format('YYYY-MM-DD');
                } else {
                    _obj['endDay'] = moment(fields[key].value).format('YYYY-MM-DD');
                }
            } else {
                _obj[key] = fields[key].value;
            }
        });
        this.props.onFieldsChange(Object.assign(_obj));
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {};
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(_obj);
    }

    fieldsOnChangeImpl(fields) {
        Object.keys(fields).forEach((key, index) => { });
    }
    getOption3(data) {
        //console.log("getOption3",data);
        let dateList = [];
        let legendData = [];
        let seriesData = [];
        if (data.length) {
            dateList = data[0].detail.map(item => {
                return item.time;
            });
            //legendData = data.map(item => item.time);
            legendData = data.map(item => item.agent);
            seriesData = data.map(item => {
                let { detail } = item;
                //let ip = detail.map(d => d.ipDistinctCount);
                let sizeData = detail.map(d => d.size);
                return {
                    name: item.agent,
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    //data: ip,
                    data: sizeData,
                };
            });
        }
        //console.log('options=======', legendData, seriesData)
        const option = {
            legend: {
                data: legendData,
            },
            title: [
                {
                    text: '实时带宽(KB)',
                    //subtext: '新增IP数',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            //滚动条
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: seriesData,
        };

        return option;
    }
    getOptionSpeed(data) {
        //console.log("getOption3",data);
        let dateList = [];
        let legendData = [];
        let seriesData = [];
        //console.log("data.length",data.length);
        if (data.length) {
            dateList = data[0].detail.map(item => {
                return item.time;
            });
            //legendData = data.map(item => item.time);
            legendData = data.map(item => item.agent);
            seriesData = data.map(item => {
                let { detail } = item;
                //let ip = detail.map(d => d.ipDistinctCount);
                let sizeData = detail.map(d => d.speed);
                return {
                    name: item.agent,
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    //data: ip,
                    data: sizeData,
                };
            });
        }
        //console.log('getOptionConnectNum=======', legendData, seriesData)
        const option = {
            legend: {
                data: legendData,
            },
            title: [
                {
                    text: '平均网速(KB/s)',
                    //subtext: '',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: seriesData,
        };

        return option;
    }

    getPieChart(data) {
        var seriesData = [];

        for (var key in data) {

            if(data[key] > 0){
               
                var obj = {
                    value: data[key],
                    name: key
                };
                seriesData.push(obj);
            }
            
        }
        //console.log('getPieChart-obj', seriesData);



        var option = {
            series: [
                {
                    name: '流量占比',
                    type: 'pie',    // 设置图表类型为饼图
                    radius: '60%',  // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
                    // data: [          // 数据数组，name 为数据项名称，value 为数据项值
                    // ],
                    data: seriesData,
                    label: {
                        normal: {
                            formatter: '{b}: {d}%  ({c})',
                            //下面可以设置百分比保留一位小数
                            // formatter: function(data){
                            //     return  data.name+ " : " + data.value + " ("+data.percent.toFixed(1)+"%)";
                            // },
                            textStyle: {
                                fontWeight: 'normal',
                                fontSize: 15
                            }
                        }
                    },
                }
            ]
        };

        return option;

    }

    getMultiCurve(data) {

        //下面这三个代理商数据的顺序  需要一致  后端已经做了排序  
        let widthDataList = data.widthData;
        let connectDataList = data.connectData;
        let agentsName = data.agentList;//

        let timeList = [];//横坐标 
        var seriesNum = [];
        let legendNum = [];
        let colorNum = [];
        let color1 = ['#00aeef', '#ec008c', '#D9B300'];
        let color2 = ['#73BF00', '#6FB7B7', '#A23400'];
        let colorArr = [color1, color2];//提前设定好的两组颜色 三个曲线颜色为一组
        if (agentsName != undefined && agentsName.length > 0) {
            //以代理商为维度  一个代理商三条数据
            for (var i = 0; i < agentsName.length; i++) {

                let sizeList = [];//实时带宽 widthDataList.size
                let speedList = [];//平均网速 widthDataList.speed
                let connectList = [];//实时连接数  connectDataList.num

                if (widthDataList != undefined && widthDataList.length > 0 && widthDataList[i] != undefined) {
                    //遍历集合
                    widthDataList[i].detail.map(item => {
                        if (i === 0) {
                            timeList.push(item.time);
                        }

                        let valueSizeData = [item.time, (item.size * 8 / 1024).toFixed(2)];//实时带宽
                        var sizeObj = {
                            value: valueSizeData
                        }
                        sizeList.push(sizeObj);

                        let valueSpeedData = [item.time, item.speed.toFixed(2)];//平均网速
                        var speedObj = {
                            value: valueSpeedData
                        }
                        speedList.push(speedObj);
                    });
                }
                if (connectDataList != undefined && connectDataList.length > 0 && connectDataList[i] != undefined) {
                    connectDataList[i].detail.map(item => {
                        let valueConneData = [item.time, item.num];//实时连接数
                        var connObj = {
                            value: valueConneData
                        }
                        connectList.push(connObj);
                    });
                }

                var itemCurve = {
                    // 曲线数据配置
                    data: sizeList,
                    // 曲线名
                    name: '实时带宽(Mb)' + '-' + agentsName[i],
                    // 设置参数对应的y坐标轴的索引
                    type: 'line',
                    // 曲线平滑设置
                    smooth: true
                };
                seriesNum.push(itemCurve);
                itemCurve = {
                    data: speedList,
                    // 曲线名
                    name: '平均网速(KB/S)' + '-' + agentsName[i],
                    // 设置所在曲线对应的y坐标轴的索引
                    yAxisIndex: 1,
                    type: 'line',
                    // 曲线平滑设置
                    smooth: true
                };
                seriesNum.push(itemCurve);
                itemCurve = {
                    data: connectList,
                    name: '实时连接数' + '-' + agentsName[i],
                    // 设置参数对应的y坐标轴的索引
                    yAxisIndex: 2,
                    type: 'line',
                    // 曲线平滑设置
                    smooth: true
                };
                seriesNum.push(itemCurve);
                legendNum.push('实时带宽(Mb)' + '-' + agentsName[i]);
                legendNum.push('平均网速(KB/S)' + '-' + agentsName[i]);
                legendNum.push('实时连接数' + '-' + agentsName[i]);
                colorNum.push(colorArr[i][0]);
                colorNum.push(colorArr[i][1]);
                colorNum.push(colorArr[i][2]);
            }

        }



        const option = {
            // 设置 x 轴的样式
            xAxis: {
                //name: '时间',
                type: 'category',
                data: timeList,
                //boundaryGap: false,
                // boundaryGap: false, //x下标在刻度处显示
                splitLine: {
                    show: true, //想要不显示网格线，改为false
                    lineStyle: {
                        // 设置网格为虚线
                        type: 'dashed'
                    }
                },
                // splitArea: { show: true }, //保留网格区域
                // 设置刻度线的颜色等样式
                axisLine: {
                    lineStyle: {
                        color: 'black',
                        width: 1
                    }
                }
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            // 设置 y 轴的样式
            yAxis: [{
                name: '实时带宽',
                type: 'value',
                // max: 700,
                // min: 0,
                // 让表格的刻度向靠里侧显示
                axisTick: {
                    inside: true
                },
                axisLabel: {
                    inside: true
                },
                // 设置刻度线的颜色等样式
                axisLine: {
                    lineStyle: {
                        color: '#00aeef',
                        width: 2
                    }
                },
                splitLine: {
                    show: true, //想要不显示网格线，改为false
                    lineStyle: {
                        // 设置网格为虚线
                        type: 'dashed'
                    }
                }
            },
            {
                name: '平均网速',
                // max: 800,
                // min: 0,
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#ec008c',
                        width: 2
                    }
                },
                splitLine: {
                    show: false //想要不显示网格线，改为false
                },
                // 设置坐标轴偏移位置
                offset: -1050
            },
            {
                name: '实时连接数',
                // max: 900,
                // min: 0,
                type: 'value',
                axisLine: {
                    lineStyle: {
                        color: '#D9B300',
                        width: 2
                    }
                },
                offset: 0,
                splitLine: {
                    show: false //想要不显示网格线，改为false
                }
            }],
            // 调整表格两边的空白的区域
            grid: { // 左侧
                //x: '20%',
                // 上部
                // y: 25,
                // 右侧
                //x2: '20%'
                // 下部
                // y2: 35
            },
            // 设置每条曲线的数据和样式
            series: seriesNum,
            // 设置鼠标hover时的提示信息
            tooltip: {
                trigger: 'axis', // 有3个属性值 axis   item   none
                axisPointer: {
                    //type: 'cross',
                    label: {
                        backgroundColor: '#6a7985' //配置展示方块的背景颜色
                    }
                }
            },
            // 调整图样的名称
            legend: {
                data: legendNum
            },
            // 定义图样和每条曲线的颜色
            color: colorNum
        };

        return option;
    }


    getOptionConnectNum(data) {
        //console.log("getOption3",data);
        let dateList = [];
        let legendData = [];
        let seriesData = [];
        //console.log("data.length",data.length);
        if (data.length) {
            dateList = data[0].detail.map(item => {
                return item.time;
            });
            //legendData = data.map(item => item.time);
            legendData = data.map(item => item.agent);
            seriesData = data.map(item => {
                let { detail } = item;
                //let ip = detail.map(d => d.ipDistinctCount);
                let sizeData = detail.map(d => d.num);
                return {
                    name: item.agent,
                    type: 'line',
                    smooth: true,
                    symbol: 'none',
                    sampling: 'average',
                    markLine: {},
                    //data: ip,
                    data: sizeData,
                };
            });
        }
        //console.log('getOptionConnectNum=======', legendData, seriesData)
        const option = {
            legend: {
                data: legendData,
            },
            title: [
                {
                    text: '实时连接数',
                    //subtext: '新增IP数',
                },
            ],
            tooltip: {
                trigger: 'axis',
            },
            xAxis: [
                {
                    type: 'category',
                    boundaryGap: false,
                    data: dateList,
                },
            ],
            yAxis: {
                type: 'value',
                axisLabel: {
                    formatter: '{value}',
                },
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: seriesData,
        };

        return option;
    }

    getOtion(data, name) {
        const option = {
            title: {
                text: name,
            },
            tooltip: {
                trigger: 'axis',
            },
            legend: {
                data: data.legend,
            },
            grid: {
                left: '3%',
                right: '4%',
                bottom: 40,
                containLabel: true,
            },
            xAxis: {
                type: 'category',
                boundaryGap: false,
                data: data.xAxis,
            },
            yAxis: {
                type: 'value',
            },
            dataZoom: [
                {
                    type: 'inside',
                    start: 0,
                    end: 100,
                },
                {
                    start: 0,
                    end: 10,
                    handleIcon:
                        'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '80%',
                    handleStyle: {
                        color: '#fff',
                        shadowBlur: 3,
                        shadowColor: 'rgba(0, 0, 0, 0.6)',
                        shadowOffsetX: 2,
                        shadowOffsetY: 2,
                    },
                },
            ],
            series: data.series,
        };
        return option;
    }

    cleaningEchartsData(xyData, lineName) {
        if (JSON.stringify(xyData) === '[]') {
            return {};
        }

        let xAxisData = xyData.xData;
        let legendData = [], seriesData = [];
        legendData = xyData.yData;

        let line = {
            name: lineName,
            smooth: true,
            type: 'line',
            data: xyData.yData,
        };
        seriesData.push(line);
        return {
            xAxis: xAxisData,
            series: seriesData,
            legend: legendData,
        };
    }

    render() {

        let columns1 = [
            {
                title: '代理商',
                dataIndex: 'agant',
            },
            {
                title: '样本数',
                dataIndex: 'sampleSize',
            },
            {
                title: 'ip去重数',
                dataIndex: 'ipDistinctNum',
            },
            {
                title: '平均网速/KB',
                dataIndex: 'avgSpeed',
                sorter: (a, b) => a.avgSpeed - b.avgSpeed,
            },
            {
                title: '最高网速/KB',
                dataIndex: 'maxSpeed',
                sorter: (a, b) => a.maxSpeed - b.maxSpeed,
            },
            {
                title: '平均带宽/Kb',
                dataIndex: 'avgWidth',
                sorter: (a, b) => a.avgWidth - b.avgWidth,
                render: (text, record) => (
                    (text * 8)
                )
            },
            {
                title: '最大带宽/Kb',
                dataIndex: 'maxWidth',
                sorter: (a, b) => a.maxWidth - b.maxWidth,
                render: (text, record) => (
                    (text * 8)
                )
            },

        ];
        let columns2 = [
            {
                title: '代理商',
                dataIndex: 'agant',
            },
            {
                title: '地区',
                dataIndex: 'area',
            },
            {
                title: '样本数',
                dataIndex: 'sampleSize',
                sorter: (a, b) => a.sampleSize - b.sampleSize,
            },
            {
                title: 'ip去重数',
                dataIndex: 'ipDistinctNum',
                sorter: (a, b) => a.ipDistinctNum - b.ipDistinctNum,
            },
            {
                title: '平均网速/KB',
                dataIndex: 'avgSpeed',
                sorter: (a, b) => a.avgSpeed - b.avgSpeed,
                // render: (text, record) => (
                //     (text/1024).toFixed(2)
                // )
            },
            {
                title: '最高网速/KB',
                dataIndex: 'maxSpeed',
                sorter: (a, b) => a.maxSpeed - b.maxSpeed,
            },
            {
                title: '平均带宽/Kb',
                dataIndex: 'avgWidth',
                sorter: (a, b) => a.avgWidth - b.avgWidth,
                render: (text, record) => (
                    (text * 8)
                )
            },
            {
                title: '最大带宽/Kb',
                dataIndex: 'maxWidth',
                sorter: (a, b) => a.maxWidth - b.maxWidth,
                render: (text, record) => (
                    (text * 8)
                )
            },

            {
                title: 'ip平均连接数',
                dataIndex: 'avgIpConnNum',
                sorter: (a, b) => a.avgIpConnNum - b.avgIpConnNum,
            },
        ];
        const { loading, bandwidthDetail, bandwidthDetailSort, widthData, connectData, multiCurveData, pieData } = this.props;

        return (
            <div style={{ marginBottom: '20px' }}>
                <Spin spinning={loading} tip="加载中">
                    <Row style={{ marginTop: '10px', marginTop: '10px' }}>
                        <SearchForm {...this.props} handleOnFieldsChange={this.handleOnFieldsChange} />
                    </Row>
                    <Tabs defaultActiveKey="1" onChange={this.updateType}>
                        <TabPane tab="数据统计" key="1">
                            {/* <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                                <Col span={12} style={{ textAlign: 'center' }}>
                                    <ReactEcharts
                                        option={this.getOption3.bind(this)(widthData)}
                                        style={{ height: '350px', width: '90%' }}
                                        className="react_for_echarts"
                                        notMerge={true}
                                        lazyUpdate={true}
                                    />
                                </Col>
                                <Col span={12} style={{ textAlign: 'center' }}>
                                    <ReactEcharts
                                        option={this.getOptionSpeed.bind(this)(widthData)}
                                        style={{ height: '350px', width: '90%' }}
                                        className="react_for_echarts"
                                        notMerge={true}
                                        lazyUpdate={true}
                                    />
                                </Col>
                            </Row> */}
                            <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                                {/* <Col span={12} style={{ textAlign: 'center' }}>
                                    <ReactEcharts
                                        option={this.getOptionConnectNum.bind(this)(connectData)}
                                        style={{ height: '350px', width: '90%' }}
                                        className="react_for_echarts"
                                        notMerge={true}
                                        lazyUpdate={true}
                                    />
                                </Col> */}
                                <Col span={12} style={{ textAlign: 'center' }}>
                                    <ReactEcharts
                                        option={this.getMultiCurve.bind(this)(multiCurveData)}
                                        style={{ height: '350px', width: '90%' }}
                                        className="react_for_echarts"
                                        notMerge={true}
                                        lazyUpdate={true}
                                    />
                                </Col>
                            </Row>
                            <Table columns={columns2} dataSource={bandwidthDetail} pagination={false} bordered />
                        </TabPane>

                        <TabPane tab="流量占比(Mb)" key="2" >
                            <Row className="graphs" style={{ marginTop: '10px', marginTop: '10px' }}>
                                <Col span={12} style={{ textAlign: 'center' }}>
                                    <ReactEcharts
                                        option={this.getPieChart.bind(this)(pieData)}
                                        style={{ height: '350px', width: '90%' }}
                                        className="react_for_echarts"
                                        notMerge={true}
                                        lazyUpdate={true}
                                    />
                                </Col>
                            </Row>
                        </TabPane>

                        <TabPane tab="代理排名" key="3" >
                            <Table columns={columns1} dataSource={bandwidthDetailSort} pagination={false} bordered />
                        </TabPane>

                    </Tabs>
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.widthAndConnect.loading.loading,
    search: state.widthAndConnect.search,
    agents: state.widthAndConnect.agents,
    areas: state.widthAndConnect.areas,
    agentCurveData: state.widthAndConnect.agentCurveData,
    widthData: state.widthAndConnect.widthData,
    connectData: state.widthAndConnect.connectData,
    multiCurveData: state.widthAndConnect.multiCurveData,
    pieData: state.widthAndConnect.pieData,
    bandwidthDetail: state.widthAndConnect.bandwidthDetail,
    bandwidthDetailSort: state.widthAndConnect.bandwidthDetailSort,


});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: search => dispatch(onFieldsChange(search)),
    getAgentsInfo: () => dispatch(getAgentsInfo()),
    getAgentQualityList: () => dispatch(getAgentQualityList()),
    getBandwidthDetail: () => dispatch(getBandwidthDetailList()),
    getBandwidthDetailSortList: () => dispatch(getBandwidthDetailSortList()),
    getPieData: () => dispatch(getPieData()),

});

export default connect(mapStateToProps, mapDispatchToProps)(widthAndConnect);

class Search extends React.Component {
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    // 查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getAgentQualityList(); //三条曲线数据
        this.props.getBandwidthDetail();//带宽详细信息
        this.props.getPieData();//饼状图信息
    }

    render() {
        const { agents, areas } = this.props;
        const { getFieldDecorator } = this.props.form;

        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>代理质量统计</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>

                        <Col span={6}>
                            <FormItem label="合作商" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('agent')(
                                    <Select allowClear mode="multiple" placeholder="全部" style={{ width: 200 }}>
                                        {agents.map((item, index) => {
                                            return (
                                                <Option key={index} value={item}>
                                                    {item}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="地区" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('area')(
                                    <Select allowClear placeholder="全部" style={{ width: 200 }}>
                                        {areas.map((item, index) => {
                                            return (
                                                <Option key={index} value={item}>
                                                    {item}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6} >
                            <FormItem label="开始日期" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('startDay')(
                                    <DatePicker
                                        style={{ width: 200 }}
                                        format="YYYY-MM-DD"
                                    />,
                                )}
                            </FormItem>

                        </Col>
                        <Col span={6} >
                            <FormItem label="结束日期" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('endDay')(
                                    <DatePicker
                                        style={{ width: 200 }}
                                        format="YYYY-MM-DD"
                                    />,
                                )}
                            </FormItem>

                        </Col>
                    </Row>

                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>
                                重置
                            </Button>&nbsp;&nbsp;&nbsp;&nbsp;
                            <Button type="primary" htmlType="submit">
                                搜索
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    },
    mapPropsToFields(props) {
        return {
            beginTimeView: {
                value: props.search.beginTimeView,
            },
            agent: {
                value: props.search.agent,
            }
        };
    },

})(Search);



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/widthAndConnect/index.js